import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
    GuestFormType,
    GuestManagementComponent
} from '@employee-pages/badge-request-page/employee-member-firm-visitor/add-guest/guest-management';
import { AutomaticCroppingService } from '@ui-app/services/automatic-cropping.service';
import { EmployeeBusinessService } from '../../../../core/services/business.service';
import { ImageService } from '@ui-app/services/image.service';
import { IGuestRequest } from '@employee-pages/badge-request-page/usi-employee-badge-forms';
import { PhotoData } from '@shared-models/common.models';
import * as EmployeeModels from '@employee-models/index';
import { IBadgeRequestPhotoInfo } from '@employee-models/data.models';
import { ISearchEmployeeApprovers } from '@employee-models/common.models';
import { REGEX_EMAIL_FORMAT, REGEX_MFIRM_MOBILE_FORMAT, REGEX_MOBILE_FORMAT } from '@employee-models/common.enums';
import { UserRoleEnum } from '@employee-models/data.enums';
import { combineLatest, EMPTY, filter, switchMap } from 'rxjs';
import { InfoModalComponent } from '@ui-app/modals/info-modal/info-modal.component';
import { MemberFirmVisitorVisaTypeEnum, MemberFirmVisitorVisitReasonEnum } from '@employee-models/data.enums';
import { Router } from '@angular/router';
import { RoutesConfig } from '@employee-configs/routes.config';
import { ApiConfig } from '@employee-configs/api.config';


@Component({
    selector: 'employee-edit-guest',
    templateUrl: './add-guest.component.html',
    styleUrls: ['./add-guest.component.less']
})
export class EditGuestComponent extends GuestManagementComponent implements OnInit {
    @Output() guestEdited = new EventEmitter<any>();
    @Output() formDirty = new EventEmitter<boolean>();
    @Input() guestData: IGuestRequest;
    @Input() visitorForm: FormGroup;
    @Input() isBadgeExtension: boolean = false;
    addGuestForm: FormGroup;
    user: any;
    DisplayDate = 90;
    attachmentsList: any[] = [];
    
    readonly uploadAttachmentConfig = {
        title: 'Upload Attachments',
        button: 'Add',
        areaTitle: 'Drag & Drop files here or',
        customRestrictions: 'You can add up to 10 files with max size 5 MB each <br> Supported formats: PDF, XLS, DOC, PPT, JPEG, JPG, PNG, ZIP',
        maxFilesCount: 10,
        formats: ['JPG', 'PDF', 'XLS', 'DOC', 'PPT', 'JPEG', 'PNG', 'ZIP', 'XLSX'],
        maxFileSize: 5 * 1024 * 1024,
        isAttachment: true,
        isBulkVisitorUpload: false,
        errors: {
            filesCount: 'Maximum 10 files can be uploaded at once',
            faceRecognition: `The photo isn't individual or face isn't clear on the photo. Please, upload another photo`,
        },
    };
    // @Input() newFileName: string = null;
    // @Input() requestData: EmployeeModels.DM.IBadgeRequestInfoEmployee;
    // @Output() onUpload = new EventEmitter<IBadgeRequestPhotoInfo>();

    title = 'Edit guest';
    buttonSubmitTitle = 'Save';
    guestFormType = GuestFormType.EDIT;
    showVisitReason = true;
    skipVisaTypeInit = true;

    constructor(protected fb: FormBuilder,
        automaticCroppingService: AutomaticCroppingService,
        employeeBusinessService: EmployeeBusinessService,
        imageService: ImageService,
        public router: Router
    ) {
        super(fb, automaticCroppingService, employeeBusinessService, imageService);
        this.employeeBusinessService.userProfileService.userData$.subscribe(data => this.user = data);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.createForm(); // Initialize the form
        this.fillForm();// Populate the form with guestData
        if (this.guestData?.photoInfo) {
            this.userPhotoUrl = this.guestData?.photoInfo['file'].url;
            this.photoData = this.guestData.photoInfo['file'];
        }
        // Initialize empty attachmentsList - existing attachments are in form control
        this.attachmentsList = [];


        // Listen to form value changes
        this.addGuestForm.valueChanges.subscribe(() => {
            this.onFormChange();
        });
    }
    // createForm(): void {
    //     this.addGuestForm = this.fb.group({
    //         firstName: ['', [Validators.required]],
    //         lastName: ['', [Validators.required]],
    //         phoneNumber: ['', [Validators.required, Validators.pattern(REGEX_MOBILE_FORMAT)]],
    //         emailAddress: ['', [Validators.required, Validators.pattern(REGEX_EMAIL_FORMAT)]],
    //         company: ['', [Validators.required]],
    //         visaTypeId: [''],
    //         entityOrFssId: ['', [Validators.required]],
    //         notification: [''],
    //         photoInfo: this.guestData?.photoInfo ? { file: this.guestData.photoInfo.file, croppInfo: '' } : { file: null, croppInfo: '' },
    //         visitStart: ['', [Validators.required]],
    //         visitEnd: ['', [Validators.required]],
    //         attachmentGuid: [''],
    //         approvers: [[], [Validators.required]],
    //         approversFull: [[]],
    //         accessRequiredId: ['', [Validators.required]],
    //         visitReasonId: [''],
    //     });
    // }
    createForm(): void {
        this.addGuestForm = this.fb.group({
            firstName: ['', [Validators.required]],
            lastName: ['', [Validators.required]],
            phoneNumber: ['', [Validators.required, Validators.pattern(REGEX_MFIRM_MOBILE_FORMAT)]],
            emailAddress: ['', [Validators.required, Validators.pattern(REGEX_EMAIL_FORMAT)]],
            company: ['', [Validators.required]],
            cardNumber: [this.guestData.cardNumber || '', this.isBadgeExtension ? [Validators.required, Validators.pattern(/^\d+$/)] : []],
            visaTypeId: [''],
            entityOrFssId: ['', [Validators.required]],
            notification: [''],
            //photoInfo: { file: null, croppInfo: '' },
            photoInfo: this.guestData?.photoInfo ? { file: this.guestData.photoInfo.file, croppInfo: '' } : { file: null, croppInfo: '' },
            visitStart: ['', [Validators.required, this.validateNotBeforeToday]],
            visitEnd: ['', [Validators.required, this.validateDateRange.bind(this)]],
            attachmentGuid: [''],
            approvers: [[], [Validators.required]],
            approversFull: [[]],
            accessRequiredIds: [[], [Validators.required]], // Change to array
            visitReasonId: [''],
            isBadgeExtension: [(this.guestData as any).isBadgeExtension || false],
        });

        if (this.isSeniorManager) {
            this.addGuestForm.controls.approvers.clearValidators();
            this.addGuestForm.updateValueAndValidity();
        }

        combineLatest([
            this.addGuestForm.get('visitReasonId').valueChanges
        ]).subscribe(([visitReasonId]) => {

            if (!this.showVisitReason) {
                return;
            }
            const isExternalMeet = visitReasonId === MemberFirmVisitorVisitReasonEnum.ExternalClientMeetings;

            if (isExternalMeet) {
                this.showPopup();
            }
        });

        this.addGuestForm.markAllAsTouched();
        this.addGuestForm.updateValueAndValidity();

    }



    fillForm(): void {

        this.addGuestForm.patchValue({
            firstName: this.guestData.firstName,
            lastName: this.guestData.lastName,
            phoneNumber: this.guestData.phoneNumber,
            emailAddress: this.guestData.emailAddress,
            company: this.guestData.company,
            cardNumber: this.guestData.cardNumber || '',
            visaTypeId: this.guestData.visaTypeId,
            entityOrFssId: this.guestData.entityOrFssId,
            notification: this.guestData.notification,
            photoInfo: { file: this.guestData.photoInfo?.file, croppInfo: '' },
            visitStart: this.guestData.visitStart.toString(),
            visitEnd: this.guestData.visitEnd.toString(),
            attachmentGuid: this.guestData.attachmentGuid,
            approvers: this.guestData.approvers || [],
            approversFull: this.guestData.approversFull || [],
            //accessRequiredId: this.guestData.accessRequiredId,
            accessRequiredIds: this.guestData.accessRequiredIds || [],
            visitReasonId: this.guestData.visitReasonId,
        });

        this.selectedVisaType = this.visaTypes.find(item => item.id === this.guestData.visaTypeId)?.name;
    }



    editGuest(formValue: IGuestRequest): void {
        const formValue1: any = {
            ...this.addGuestForm.value,
            visitStart: this.addGuestForm.value.visitStart.toString(),
            visitEnd: this.addGuestForm.value.visitEnd.toString(),
            approvers: this.isSeniorManager ? [this.user.userId] : this.addGuestForm.value.approvers,
            isBadgeExtension: this.addGuestForm.value.isBadgeExtension
        };
        
        // Set photoInfo={} for badge extensions
        if (formValue1.isBadgeExtension) {
            formValue1.photoInfo = {};
        }
        
        this.guestEdited.emit(formValue1 as IGuestRequest);
    }


    // Call this method whenever the form is modified
    onFormChange() {
        this.formDirty.emit(this.addGuestForm.dirty);
    }

    onVisaTypeChange(value: string): void {
        const visa = this.visaTypes.find((item) => item.name === value);
        if (visa) {
            this.addGuestForm.get('visaTypeId').setValue(visa.id);

            // Clear approvers when visa type changes
            this.addGuestForm.get('approvers').setValue([]);
            this.addGuestForm.get('approversFull').setValue([]);

            this.onFormChange(); // Call onFormChange to update the formDirty status
        }
    }

    onEntityFssChange(): void {
        this.addGuestForm.controls['approver'].setValue([]);
        this.addGuestForm.markAsDirty(); // Mark the form as dirty
        this.formDirty.emit(this.addGuestForm.dirty && this.addGuestForm.valid); // Emit form dirty status
    }

    onVisitReasonChange(): void {
        this.addGuestForm.markAsDirty(); // Mark the form as dirty when visit reason changes
        this.onFormChange(); // Call onFormChange to update the formDirty status
    }

    onAccessRequiredChange(): void {
        this.addGuestForm.markAsDirty(); // Mark the form as dirty when access required changes
        this.onFormChange(); // Call onFormChange to update the formDirty status
    }

    setApprovers(approverIds: number[]): void {
        const previousApprovers = this.addGuestForm.value.approvers || [];
        this.addGuestForm.patchValue({
            approvers: approverIds
        });
        if (approverIds.length !== previousApprovers.length) {
            this.addGuestForm.markAsDirty();
        }
        this.onFormChange();
    }
    
    setFullApprovers(approvers: ISearchEmployeeApprovers[]): void {
        const previousApprovers = this.addGuestForm.value.approversFull || [];
        this.addGuestForm.patchValue({
            approversFull: approvers
        });
        if (approvers.length !== previousApprovers.length) {
            this.addGuestForm.markAsDirty();
        }
        this.onFormChange();
    }

    onAttachmentUpload(event: any[]): void {
        if (event.length > 0) {
            event.forEach(data => {
                const file = this.getFileFromPhotoData(data);
                this.attachmentsList.push(file);
            });
            
            const allGuids = this.attachmentsList.map(file => file.uId).join(',');
            
            this.addGuestForm.patchValue({
                attachmentGuid: allGuids,
            });
        }
    }

    clearAttachment(index?: number): void {
        if (index !== undefined) {
            this.attachmentsList.splice(index, 1);
            
            this.addGuestForm.patchValue({
                attachmentGuid: this.attachmentsList.length > 0 
                    ? this.attachmentsList.map(f => f.uId).join(',')
                    : null,
            });
        } else {
            this.attachmentsList = [];
            this.addGuestForm.patchValue({
                attachmentGuid: null,
            });
        }
    }

    // onPhotoUploaded(event: PhotoData): void {
    //     this.photoData = event;
    //     const file = this.getFileFromPhotoData(this.photoData);
    //     if (this.photoData.uId) {
    //         this.userPhotoUrl = this.photoData.url;
    //     }
    //     this.onUpload.emit(file);
    //     this.addGuestForm.markAsDirty(); // Mark the form as dirty
    //     this.onFormChange(); // Call formChangeHandler to update the formDirty status
    // }
    // getFileFromPhotoData(photoData: PhotoData): IBadgeRequestPhotoInfo {
    //     const { uId, contentType, length, url } = photoData;
    //     return {
    //         uId,
    //         name: this.newFileName,
    //         contentType,
    //         length,
    //         url,
    //         documentType: EmployeeModels.DE.DocumentTypeEnum.FrontFace
    //     };
    // }

    showPopup(): void {
        this.employeeBusinessService.infoModalService
            .initModal(InfoModalComponent, {
                title: 'Client Visit - Business Purpose',
                description: 'Please use the Captivate application to submit a request for a Client Visit - Business Purpose.',
                buttonsTitle: {
                    confirm: 'Go To Captivate'
                }
            })
            .pipe(
                switchMap((action: boolean) => {
                    if (action) {
                        // OK clicked
                        this.navigateToMyProfile(this.user.userId);
                        window.open(ApiConfig.RedirectUrls.captivate, '_blank');
                    } else {
                        this.showVisitReason = false;
                        this.addGuestForm.patchValue({
                            visitReasonId: ''
                        })
                        this.addGuestForm.updateValueAndValidity();
                        // Recreate after a short delay
                        setTimeout(() => {
                            this.showVisitReason = true;
                            // Optionally, set a value or perform other logic here
                        });
                    }
                    return EMPTY;
                })
            )
            .subscribe(() => {
                this.employeeBusinessService.infoModalService.closeAllModals();

            });
    }


    navigateToMyProfile(userId: number): void {
        this.router.navigate([RoutesConfig.pages.employeeProfile, userId]); // Replace with your actual route
    }

    validateDateRange(control: any): { [key: string]: boolean } | null {
        if (!this.addGuestForm) {
            return null;
        }
        
        const startDate = this.addGuestForm.get('visitStart')?.value;
        const endDate = control.value;
        
        if (!startDate || !endDate) {
            return null;
        }
        
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffTime = end.getTime() - start.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays > 90) {
            return { maxDaysExceeded: true };
        }
        
        return null;
    }

    dateChanged(): void {
        const start = Date.parse(this.addGuestForm.value.visitStart);
        const end = Date.parse(this.addGuestForm.value.visitEnd);
        
        if (start && end && start > end) {
            this.addGuestForm.patchValue({
                visitEnd: null
            });
        }
        
        // Revalidate end date when start date changes and mark as touched to show errors
        const endDateControl = this.addGuestForm.get('visitEnd');
        endDateControl?.markAsTouched();
        endDateControl?.markAsDirty();
        endDateControl?.updateValueAndValidity();
    }
}
